/* eslint-disable react-hooks/exhaustive-deps */
import { ViewDetails } from './components/view-details.component';

const SuspensionComponent = () => {
	return <ViewDetails />;
};

export default SuspensionComponent;
